import React, { Component } from "react";
export default class CustomLoader extends Component {
  render() {
    return (
      <div className="app-loader text-center d-flex align-items-center">
        <img
          alt=""
          src="/assets/images/loader.gif"
          style={{ width: "100px", height: "100px" }}
          className="mx-auto"
        />
      </div>
    );
  }
}
